<div class="py-12 md:py-16 mb-8 px-container">
    <h1 class="text-3xl md:text-5xl lg:text-6xl">Contatti</h1>
    <section class="py-8 mt-8 contatti flex flex-col gap-8 lg:gap-16 lg:flex-row">
        <div *ngFor="let contatto of contatti" class="grow relative ps-8">
            <div class="top-1/2 left-0 absolute border-gray-300 border-l-2 border-dashed w-2 h-4/5 -translate-y-1/2"></div>
            <h1 class="text-2xl font-medium mb-4">{{contatto.titolo}}</h1>
            <div [innerHTML]="contatto.descrizione"></div>
        </div>
    </section>
    <section class="my-8 text-right">

    </section>
    <section class="relative">
        <div class="info bg-white relative md:absolute top-0 left-0 py-6 px-4 z-40 mb-4 md:m-4 w-full md:w-auto">
                <h1 class="font-bold text-xl">Teatro colosseo</h1>
                <h3 class="font-mono mb-4">Via Madama Cristina 71, Torino</h3>
                <a target="_blank" href="https://www.google.com/maps/place/Teatro+Colosseo/@45.0361637,7.634003,11z/data=!3m1!5s0x47886d45a38b898d:0xcf65bceaf74b5ba5!4m6!3m5!1s0x47886d458a5912bf:0x1318479044d0699c!8m2!3d45.0523532!4d7.6793602!16s%2Fg%2F123026xr?entry=ttu&g_ep=EgoyMDI0MTAwMi4xIKXMDSoASAFQAw%3D%3D" class="cta-link">Ottieni indicazioni</a>
        </div>
        <div class="w-full h-[320px] md:h-[500px]" id="map"></div>
    </section>
</div>